/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Text, InputContainer, SendToast } from "@networkraildigitalfactory/components";
import emojiStrip from "emoji-strip";
import styles from "./CreateComment.module.css";
import { useComments } from "../../hooks/useAPI";
import { a11yGrowTextarea } from "../../services/utils";

const CreateComment = (props) => {
  const { reset, register, handleSubmit, errors, formState } = useForm();
  const { dirty: isDirty } = formState;
  const [, setCommentCreated] = useState();

  const {
    user,
    oneToOneId,
    objectiveId,
    pdpId,
    reviewPrepId,
    isLineManager,
    getUpdatedObjective,
    getUpdatedOneToOne,
    getUpdatedPdp,
    getUpdatedReview,
    type,
    setIsDirtyForm,
  } = props;

  useEffect(() => {
    setIsDirtyForm(isDirty);
  }, [isDirty]);

  const getApiUrl = () => {
    switch (type) {
      case "objective":
        return `objective/${objectiveId}`;
      case "oneToOne":
        return `1-2-1/${oneToOneId}`;
      case "PDP":
        return `pdp/${pdpId}`;
      case "interimPrep":
      case "eoyPrep":
        return `reviewPrep/${reviewPrepId}`;
      default:
        return null;
    }
  };

  const [{ error: errPostComment }, postComment] = useComments(
    {
      url: getApiUrl(),
      method: "POST",
    },
    { manual: true }
  );

  const onSumbitComment = async (data) => {
    data = { ...data, createdBy: user.fullName, email: user.email, isLineManager, type };
    switch (type) {
      case "objective":
        data.objectiveId = objectiveId;
        break;
      case "oneToOne":
        data.oneToOneId = oneToOneId;
        break;
      case "PDP":
        data.pdpId = pdpId;
        break;
      case "interimPrep":
      case "eoyPrep":
        data.reviewPrepId = reviewPrepId;
        data.reviewType = type.split("Prep")[0];
        break;
      default:
    }
    await postComment({
      data,
    });
    if (errPostComment) {
      SendToast("There was an error posting your comment. Please try again.", "error");
    } else {
      reset({ comment: "", dirty: false });
      if (objectiveId) {
        getUpdatedObjective();
      } else if (oneToOneId) {
        getUpdatedOneToOne();
      } else if (pdpId) {
        getUpdatedPdp();
      } else if (reviewPrepId) {
        getUpdatedReview();
      }
      SendToast("Your comment has been posted", "success");
    }
  };

  const getCopyText = () => {
    switch (type) {
      case "objective":
        return {
          label: "Do you have any updates or comments on this objective?",
          message: `You and your ${
            isLineManager ? "employee" : "line manager"
          } will be able to see comments that either of you have added to this objective.`,
        };
      case "PDP":
        return {
          label: "Do you have any updates or comments on this development goal?",
          message: `You and your ${
            isLineManager ? "employee" : "line manager"
          } will be able to see comments that either of you have added to this development goal.`,
        };
      case "oneToOne":
        return {
          label: isLineManager
            ? "Do you have any updates or comments on this completed 1-2-1?"
            : "Do you have any comments on this 1-2-1?",
          message: `You and your ${
            isLineManager ? "employee" : "line manager"
          } will be able to see comments that ${
            isLineManager
              ? "either of you have added to this completed 1-2-1."
              : "are added to this completed 1-2-1."
          }`,
        };
      case "interimPrep":
      case "eoyPrep":
        return {
          label: "Do you have any updates or comments on this completed review?",
          message: `You and your ${
            isLineManager ? "employee" : "line manager"
          } will be able to see comments that either of you have added to this completed review.`,
        };
      default:
        return {};
    }
  };

  const copyText = getCopyText();

  const onInputChange = (field, value) => {
    setCommentCreated((prevFormValues) => ({
      ...prevFormValues,
      [field]: emojiStrip(value),
    }));
  };

  return (
    <>
      <Text
        wrapper="h3"
        type="subtitle"
        style={{ fontSize: "20px", lineHeight: "140%", letterSpacing: "0.0015em" }}
      >
        Comments
      </Text>
      <form
        className={styles.CreateComment}
        role="presentation"
        onSubmit={handleSubmit(onSumbitComment)}
      >
        <InputContainer
          labelText={copyText.label}
          forLabel="comment"
          errorText={errors.comment && errors.comment.message}
        >
          <textarea
            name="comment"
            id="comment"
            className={`${styles.comment_input} ${errors.comment && styles.error}`}
            type="text"
            ref={register({
              required: "Must not be blank",
            })}
            onChange={(e) => onInputChange("comment", e.target.value, false)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onInputChange("comment", e.target.value, true);
              }
              a11yGrowTextarea(e, "comment");
            }}
          />
        </InputContainer>
        <div className={styles.footer}>
          <Text wrapper="span" type="body">
            {copyText.message}
          </Text>
          <Button
            className={styles.save_comment_Btn}
            style={{
              backgroundColor: isDirty ? "#37519D" : "#727272",
            }}
            text="Save comment"
          />
        </div>
      </form>
    </>
  );
};

export default CreateComment;
